import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiPopover } from '@splashthat/sui';

import BorderPickerDropdownOption from './BorderPickerDropdownOption';

import Check from '../../../icons/Check';

const BASE_CLASS_NAME = 'BorderPickerDropdownPopover';

export default class BorderPickerDropdownPopover extends Component {
    static propTypes = {
        widthOptions: PropTypes.array,
        showPopover: PropTypes.bool.isRequired,
        onClickClose: PropTypes.func.isRequired,
        anchorEl: PropTypes.object,
        minWidth: PropTypes.number.isRequired,
        onBorderWidthsChanged: PropTypes.func.isRequired,
        defaultBorderWidth: PropTypes.number.isRequired,
        qaId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        widthOptions: [],
        anchorEl: null,
    };

    wrapperRef = React.createRef();
    buttonRef = React.createRef();

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
        this.buttonRef && this.buttonRef.current && this.buttonRef.current.focus();
    }

    componentWillUnmount = () => {
        document.removeEventListener('click', this.handleOutsideClick, false);
    };

    handleOutsideClick = (event) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.onClickClose();
        }
    };

    handleClick = (width) => {
        this.props.onBorderWidthsChanged(width);
        this.props.onClickClose();
    };

    render() {
        const { widthOptions, showPopover, anchorEl, minWidth, defaultBorderWidth, qaId } = this.props;

        return (
            <SuiPopover open={showPopover} anchorEl={anchorEl}>
                <div ref={this.wrapperRef}>
                    <SuiContainer className={`${BASE_CLASS_NAME}__popover`} style={{ minWidth }}>
                        {widthOptions.map((width, i) => (
                            <button
                                data-qa={`${qaId}--option-${i}`}
                                key={i}
                                className={`${BASE_CLASS_NAME}__popover--content`}
                                onClick={() => this.handleClick(width)}
                                ref={defaultBorderWidth === width ? this.buttonRef : null}
                            >
                                <BorderPickerDropdownOption height={width} />
                                {defaultBorderWidth === width ? <Check /> : null}
                            </button>
                        ))}
                    </SuiContainer>
                </div>
            </SuiPopover>
        );
    }
}
